import React from 'react';
import { Link } from 'react-router-dom';
import { BlogPost } from '../../lib/blog';
import { formatDate } from '../../utils/date';

interface BlogCardProps {
    post: BlogPost;
}

export default function BlogCard({ post }: BlogCardProps) {
    return (
        <Link to={`/blog/${post.slug}`} className="w-full">
            <article className="w-full group bg-white rounded-2xl shadow-sm border border-gray-200 overflow-hidden hover:shadow-md transition-all duration-300">
                {/* Image */}
                <div className="h-48 overflow-hidden bg-[#f2f2f3]">
                    <img
                        src={post.cover || "/images/blog/Whisk_7360f2eafe.jpg"}
                        alt={post.title}
                        className="w-full h-full object-cover"
                    />
                </div>

                {/* Content */}
                <div className="p-6">
                    {/* Title */}
                    <h3 className="text-xl font-bold text-gray-900 mb-4 group-hover:text-[#6547D9] transition-colors duration-200 line-clamp-2">
                        {post.title}
                    </h3>

                    {/* Excerpt */}
                    {post.excerpt && (
                        <p className="text-gray-600 text-base leading-relaxed mb-4 line-clamp-3">
                            {post.excerpt}
                        </p>
                    )}

                    {/* Author and Date */}
                    <div className="flex items-center justify-between pt-4 border-t border-gray-100">
                        <div className="flex items-center space-x-3">
                            <img 
                                src="https://unavatar.io/x/tarunyadav9761"
                                alt="Tarun Yadav"
                                className="w-8 h-8 rounded-full object-cover"
                            />
                            <div>
                                <p className="text-sm font-medium text-gray-900">Tarun Yadav</p>
                                <time
                                    dateTime={post.date}
                                    className="text-xs text-gray-500"
                                >
                                    {formatDate(post.date)}
                                </time>
                            </div>
                        </div>
                        <span className="text-[#6547D9] font-medium text-sm group-hover:text-[#5638C7] transition-colors duration-200">
                            Read →
                        </span>
                    </div>
                </div>
            </article>
        </Link>
    );
}
